import React from 'react';
import TableColumnTitle from '../../../../../../../components/_table/TableColumnTitle';
import { Columns } from '../../../../../../../types/common/table';

export const categoryTreeColumn: Columns<{ id: number; name: string }, Record<string, unknown>> = () => {
  return [
    {
      title: <TableColumnTitle title={'상품 카테고리 ID'} />,
      dataIndex: 'id',
    },
    {
      title: <TableColumnTitle title={'상품 카테고리명'} />,
      dataIndex: 'name',
      width: 300,
    },
  ];
};
